import moment from 'moment';

export default (date: Date | string) => {
  // Using moment because `new Date(date)` differs between Safari and other browsers.
  return moment(date).toDate();
};
